import { useEffect, useState } from 'react';
import { Button, Grid } from '@mui/material';
import useGlobalContext from '../../Hooks/useGlobalContext';
import { useTranslation } from 'react-i18next';
import AssetValidationTable from './components/AssetValidationTable';
import AssetSelectEstablishmentFilter from './components/AssetSelectEstablishmentFilter';
import { putObjectsMassive } from '../../services/object';
import { toast, ToastContainer } from 'material-react-toastify';
import ModalConfirmOrDecline from '../../Components/Feature/ModalConfirmOrDecline';

const AssetValidations = () => {
  const { t } = useTranslation();
  const globalContext = useGlobalContext();
  const { selectedAsset } = globalContext;
  const [rows] = useState([]);
  const [fields, setFields] = useState([]);

  const [selectedAssetsToValidate, setSelectedAssetsToValidate] = useState([]);

  const [selectedValidatedCompany, setSelectedValidatedCompany] = useState(null);
  const [selectedValidatedBox, setSelectedValidatedBox] = useState(null);

  const [refreshKey, setRefreshKey] = useState(0);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getModels = () => {
    try {
      if (selectedAsset.id !== -1) {
        let models = globalContext.getSessionDataByKey('models');
        if (models != null) {
          let model = selectedAsset.id;
          if (models[model]) {
            setFields(models[model].attributes);
            return models;
          }
        }
      }
      return null;
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    if (selectedAsset.id !== -1) {
      getModels();
    }
  }, [selectedAsset.id]);

  useEffect(() => {
    setSelectedAssetsToValidate([]);
  }, [selectedValidatedBox]);

  const validateSelectedAssets = () => {
    setIsLoading(true);
    if (!selectedAssetsToValidate || selectedAssetsToValidate.length === 0) {
      console.log('No assets selected for validation');
      return;
    }

    const values = selectedAssetsToValidate.map((assetId) => ({
      asset_status_change: 'validated',
      pk: assetId,
    }));

    const labels = selectedAssetsToValidate.map(() => ({
      asset_status_change: 'Validado',
    }));

    const dataObj = {
      values: values,
      labels: labels,
      headerValues: {},
      action: 'update',
      pk: null,
      objectType: 'asset',
      pkObjectType: selectedAsset.id,
      pkReferer: null,
      holder: selectedValidatedBox.id,
      temporalDetailParentId: -1,
      globalModel: selectedAsset.id,
      actionContext: {
        context: 'massive_manual_form',
        eventType: 6,
      },
    };

    putObjectsMassive(dataObj)
      .then((response) => {
        toast.success(t('validations.common.success'), {
          className: 'toast-message-body',
          progressClassName: 'toast-message-progress',
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {
        console.error(t('validations.common.error'), error);
        toast.error('Validating was wrong', {
          className: 'toast-message-body',
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          progressStyle: { backgroundColor: '#D32F2F' },
        });
      })
      .finally(() => {
        setRefreshKey(Date.now() - 1);
        setIsLoading(false);
        setOpenConfirmationModal(false);
        setSelectedAssetsToValidate([]);
      });

    return;
  };

  const ValidateButton = () => {
    return (
      <Button
        disabled={
          !selectedAssetsToValidate ||
          selectedAssetsToValidate.length === 0 ||
          isLoading
        }
        color="primary"
        variant="contained"
        onClick={() => setOpenConfirmationModal(true)}>
        {t('validations.common.validate')}
      </Button>
    );
  };

  return (
    <>
      <Grid container spacing={2}>
        <AssetSelectEstablishmentFilter
          selectedValidatedCompany={selectedValidatedCompany}
          onChangeCompany={setSelectedValidatedCompany}
          selectedValidatedBox={selectedValidatedBox}
          onChangeBox={setSelectedValidatedBox}
        />
        <Grid item xs={12}>
          {selectedValidatedBox && selectedValidatedBox.id && (
            <AssetValidationTable
              multiSelectMode={true}
              onMultipleSelected={(evt) => {}}
              parentType={'box'}
              parentTypeSubType={'38'}
              show={true}
              onSelected={() => {}}
              rows={rows}
              fields={fields}
              onChangeRowCount={() => {}}
              entity={'asset'}
              url={`objects/get/all/${selectedAsset.id}/asset/${selectedAsset.id}/${selectedValidatedBox.id}/0/0`}
              sessionContext={'assetsValidation'}
              selectedBox={selectedValidatedBox}
              selectedCompany={selectedValidatedCompany}
              validateAssetsButton={<ValidateButton />}
              onSelectedRowsChange={setSelectedAssetsToValidate}
              refreshKey={refreshKey}
            />
          )}
          {!selectedValidatedBox && t('validations.assets.mustSelectBox')}
        </Grid>
      </Grid>
      <ModalConfirmOrDecline
        open={openConfirmationModal}
        modalText={t('validations.assets.confirmValidation')}
        toggleModal={setOpenConfirmationModal}
        handleAction={validateSelectedAssets}
        data={''}
        isLoading={isLoading}
      />
      <ToastContainer />
    </>
  );
};

export default AssetValidations;
